export type CabinetErrorCode = 401 | 403 | 404 | 500 | 503;

export type CabinetErrorCopy = {
  code: CabinetErrorCode;
  title: string;
  description: string;
  happenedTitle: string;
  happened: string;
  fixTitle: string;
  fix: string;
  homeLabel: string;
  loginLabel?: string;
};

export const CABINET_ERROR_PAGES: Record<CabinetErrorCode, CabinetErrorCopy> = {
  401: {
    code: 401,
    title: 'Ошибка 401',
    description: 'Сессия закончилась. Войдите снова, чтобы открыть кабинет.',
    happenedTitle: 'Что случилось?',
    happened: 'Без входа кабинет не открывается. Возможно, вы вышли или ссылка устарела.',
    fixTitle: 'Как исправить?',
    fix: 'Войдите в аккаунт. После входа вас вернет к нужной странице, если ссылка еще действует.',
    homeLabel: 'На главную',
    loginLabel: 'Войти',
  },
  403: {
    code: 403,
    title: 'Ошибка 403',
    description: 'У этого раздела другой класс. Вам сюда пока нельзя.',
    happenedTitle: 'Что случилось?',
    happened: 'Страница есть, но для вашей роли она закрыта. Так бывает, если открыть чужой кабинет.',
    fixTitle: 'Как исправить?',
    fix: 'Вернитесь в свой кабинет. Если права должны быть - напишите в поддержку через "Помощь".',
    homeLabel: 'В кабинет',
  },
  404: {
    code: 404,
    title: 'Ошибка 404',
    description: 'О себе эта страница пока ничего не может сказать - она еще учится.',
    happenedTitle: 'Что случилось?',
    happened:
      'Такой страницы нет. Возможно, адрес набрали с опечаткой или ссылка уже не действует.',
    fixTitle: 'Как исправить?',
    fix: 'Проверьте адрес или вернитесь в кабинет. Если страница точно должна быть - обновите вкладку: могли идти технические работы.',
    homeLabel: 'Вернуться на главную',
  },
  500: {
    code: 500,
    title: 'Ошибка 500',
    description: 'Кабинет споткнулся. Это не ваша ошибка - страница просто не собралась.',
    happenedTitle: 'Что случилось?',
    happened: 'Внутренний сбой. Данные не открылись, хотя адрес мог быть верным.',
    fixTitle: 'Как исправить?',
    fix: 'Обновите страницу. Если снова ошибка - вернитесь в кабинет и откройте раздел заново.',
    homeLabel: 'В кабинет',
  },
  503: {
    code: 503,
    title: 'Ошибка 503',
    description: 'Кабинет на перемене. Обычно это коротко.',
    happenedTitle: 'Что случилось?',
    happened: 'Сервис временно недоступен: обновление или слишком много запросов сразу.',
    fixTitle: 'Как исправить?',
    fix: 'Подождите минуту и обновите страницу. Если спешите - попробуйте позже.',
    homeLabel: 'В кабинет',
  },
};

export function resolveCabinetErrorCode(value: unknown): CabinetErrorCode {
  const numeric = typeof value === 'number' ? value : Number(value);
  if (numeric === 401 || numeric === 403 || numeric === 404 || numeric === 500 || numeric === 503) {
    return numeric;
  }
  return 500;
}

/** Session/API outage: gateways and network failures are a 503, not a 404. */
export function resolveSessionUnavailableCode(error: unknown): CabinetErrorCode {
  const status =
    typeof error === 'object' &&
    error !== null &&
    'response' in error &&
    typeof (error as { response?: { status?: unknown } }).response?.status === 'number'
      ? (error as { response: { status: number } }).response.status
      : undefined;

  if (status == null || status === 502 || status === 503 || status === 504) {
    return 503;
  }
  return resolveCabinetErrorCode(status);
}
